import React from "react";
import { Switch,Route, Redirect } from "react-router-dom";

// @material-ui/core components
import AuthNavbar from "beaktShared/components/Navbars/AuthNavbar.js";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import login from "assets/img/login-clinic.jpg";

import routes from "beaktClinic/routesclinic";

const useStyles = makeStyles(styles);

export default function Pages(props) {
  const { ...rest } = props;
  // ref for the wrapper div
  const wrapper = React.createRef();
  // styles
  const classes = useStyles();
  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBgImage = () => {
    return login;
  };
  
  let [logowhite] = React.useState(require("assets/img/logotipo-white-clinic.png"));
  return (
    <div>
      <div className={classes.wrapper} ref={wrapper}>
        <div
          className={classes.fullPage}
          style={{ backgroundImage: "url(" + getBgImage() + ")" }}
        >
          <div style={{position:'absolute',top:'30px',right:'0',left:'0'}}>
            <center><img width="180px" alt="logo" src={logowhite}/></center>
          </div>
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
      
        </div>
      </div>
    </div>
  );
}
